import createStore from 'unistore'

const initialState = {
  isNarrow: window.innerWidth < 700,
  isWide: window.innerWidth >= 1100
}

export const store = createStore(initialState)
